"use strict";

/**
 * 50/50 Block
 * JavaScript for the 50-50 block functionality
 */

(function ($) {
  'use strict';

  // Initialize wave borders for this block
  // Note: The shared wave-borders.js file should be loaded before this file
  // or you can import it if using a module system
  if (typeof initWaveBorders === 'function') {
    initWaveBorders('.alternating-50-50-block--has-waves');
  } else {
    // Fallback if shared file isn't loaded - inline the function
    var initWaveClipPaths = function initWaveClipPaths() {
      var blocksWithWaves = document.querySelectorAll('.alternating-50-50-block--has-waves');
      blocksWithWaves.forEach(function (block) {
        var blockId = block.id;
        if (blockId) {
          var clipPathId = "wave-clip-".concat(blockId);
          var clipPathElement = document.querySelector("#".concat(clipPathId));
          if (clipPathElement) {
            block.style.clipPath = "url(#".concat(clipPathId, ")");
            block.style.webkitClipPath = "url(#".concat(clipPathId, ")");
          }
        }
      });
    };
    var initialize = function initialize() {
      initWaveClipPaths();
      setTimeout(initWaveClipPaths, 100);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  }
})(jQuery);